export const worldZhCN = {
  'world.seo.title': '世界',
  'world.seo.description':
    '探索 Grymwyrd 的交互地图 — 其王国、遗迹和传奇场景，涵盖 2D 平面图和可旋转的 3D 地球。',
  'world.heading': '世界',
  'world.intro':
    '绘制永恒的暮光之地。本地图集为嵌套式浏览而设 — 从整个世界缩放至单一地牢。目前仅顶层为交互式；随着诸界地图完成，更深层将陆续开放。',

  'world.viewMode.label': '地图视图模式',
  'world.viewMode.map2d': '2D 地图',
  'world.viewMode.globe3d': '3D 地球',

  'world.gazetteer.navLabel': '地点与场景',
  'world.gazetteer.heading': '地名辞典',
  'world.gazetteer.sampleNotice':
    '显示示例地点 — 地图绘制者的真正调查还未记录。',
  'world.gazetteer.error': '无法访问地图集档案。',

  'world.loading.atlas': '展开地图集…',
  'world.loading.globe': '旋转世界…',

  'world.layersActive': '{active} 个 / {total} 个图层已激活。',
  'world.globeHint':
    '拖动旋转（探索时自动停止旋转，闲置一分钟后恢复）；滚动放大。悬停六边形显示其战役，点击进入。',
  'world.webglUnavailable':
    '3D 地球需要 WebGL 支持，此环境不可用 — 改为显示 2D 地图。',

  'world.campaign.capitalRegion': '中央地区',
  'world.campaign.territory': '战役领地',
  'world.campaign.enter': '进入战役',
  'world.campaign.stay': '保持轨道',

  'world.layers.heading': '地图图层',
  'world.layers.gmBadge': '主持人',
  'world.layers.gmRequired': '需要主持人身份。',

  'world.marker.sampleBadge': '示例数据',
  'world.marker.viewInEncyclopedia': '在百科中查看',
  'world.marker.placeholderNote':
    '这是占位符地点 — 一旦其背景故事被记录，它将链接到百科。',

  'world.map2d.ariaLabel': '交互式世界地图',
  'world.map2d.noOverworld': '世界地图还未绘制 — 显示虚空',

  'world.globe.hint.enter': '进入 ▸',
  'world.globe.hint.open': '打开 ▸',
  'world.globe.hint.claim': '占领 ▸',
  'world.globe.uncharted': '未探索区域',
  'world.globe.unchartedBlurb':
    '无战役已在永恒暮光之地的此十六进制区域中扎根。插上第一面旗帜。',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
